import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "@/components/ui/card";
import { useEvents } from "@/context/EventsContext";

const HourlyBars = ({ buckets }: { buckets: number[] }) => {
  const max = Math.max(...buckets);

  return (
    <div className="flex items-end gap-[2px] h-10 w-full border-b border-muted">
      {buckets.map((count, i) => {
        const isEmpty = count === 0;
        // Pure linear scale so 1 bar of max becomes full-height.
        const heightPct = max > 0 ? (count / max) * 100 : 0;
        return (
          <div
            key={i}
            className="flex-1 flex items-end h-full"
            title={`${count} event${count === 1 ? '' : 's'} · ${23 - i}h ago`}
          >
            {!isEmpty && (
              <div
                className="w-full rounded-sm bg-primary/70"
                style={{ height: `${heightPct}%` }}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export const EventsMetrics = (): React.ReactNode => {
  const { recentCounts } = useEvents();

  return (
    <Card x-chunk="dashboard-05-chunk-1" className="flex flex-col h-full">
      <CardHeader className="pb-2">
        <CardDescription>Events · Last 6h</CardDescription>
        <CardTitle className="text-6xl font-bold">{recentCounts.last6Hours}</CardTitle>
      </CardHeader>
      <CardContent className="pb-4 flex flex-col gap-3 mt-auto">
        <HourlyBars buckets={recentCounts.hourlyBuckets} />
        <p className="text-xs text-muted-foreground">
          {recentCounts.last24Hours} in the last 24 hours
        </p>
      </CardContent>
    </Card>
  );
};
